import {get, isEqual, omit, map} from "lodash"
import {cycleQuestionsFragment} from "@irati/insights/apollo/gql/fragments/schedule"

const questionsCloneHasChanges = (client, clone, cycleId) => {
  const questionData = client.cache.readFragment({
    id: `Schedule@${cycleId}`,
    fragment: cycleQuestionsFragment,
    fragmentName: "cycleQuestions"
  })
  const questions = get(questionData, "questions.results")

  return !isEqual(map(questions, (q) => omit(q, "uuid")), map(clone, (q) => omit(q, "uuid")))
}

export default questionsCloneHasChanges
